import { useAppSelector } from "../../../state/store"

export const useAppUi = () => useAppSelector((state) => state.ui)
